export const ACTION_IDS = {
	APPROVE: 'approve',
	REJECT: 'reject',
	UPLOAD: 'upload'
};

export const ACTION_LABELS = {
	[ACTION_IDS.APPROVE]: 'Approve',
	[ACTION_IDS.REJECT]: 'Reject',
	[ACTION_IDS.UPLOAD]: 'Upload KYC'
};

export const BUTTON_LABELS = {
	APPROVE_AGREE: 'Approve',
	APPROVE_DISAGREE: 'Cancel'
};

export const APPROVE_REJECT_KYC_STATUS = {
	APPROVED: 'APPROVED',
	REJECTED: 'REJECTED'
};

export const REJECT_REASONS = {
	NAME_MISMATCH: 'Name Mismatch',
	IS_MINOR: 'User Is Minor',
	DOB_MISMATCH: 'DOB Mismatch',
	BANK_UPI_NAME_MISMATCH: 'Bank/UPI Name Mismatch',
	IMAGE_NOT_CLEAR: 'Image not clear',
	DOCUMENT_DOES_NOT_BELONG_TO_USER: 'Document does not belong to user',
	INCORRECT_DOCUMENT_TYPE: 'Incorrect document type',
	INVALID_IMAGE: 'Invalid Image',
	OTHER: 'other'
};
